import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import { ReversedGradientBorder } from '../commons'
import Button from '../Button/'

const Investors = ({ title, subtitle, images }) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 450
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <ReversedGradientBorder
          className={styles.gradBorder}
          height="3px"
        ></ReversedGradientBorder>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.subtitle}>{subtitle.subtitle}</div>
        <div className={styles.investorLogos}>
          {images.map((image, idx) => (
            <div
              key={idx}
              className={styles.imageBox}
              style={{
                height: `${
                  !isMobile
                    ? image.description.split('x')[1]
                    : parseInt(image.description.split('x')[1]) / 2
                }px`,
              }}
            >
              <GatsbyImage
                image={image.gatsbyImageData}
                className={styles.investorLogo}
                style={{
                  width: `${
                    !isMobile
                      ? image.description.split('x')[0]
                      : parseInt(image.description.split('x')[0]) / 2
                  }px`,
                  height: `${
                    !isMobile
                      ? image.description.split('x')[1]
                      : parseInt(image.description.split('x')[1]) / 2
                  }px`,
                }}
                alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Investors
